import { useEffect } from 'react';
import useStudentLiveSessionStore from './studentLiveSessionStore';

interface UseStudentLiveSessionOptions {
  // Skip attach when the feature is off (e.g. teacher_paced_mode flag disabled).
  enabled?: boolean;
}

const useStudentLiveSession = ({ enabled = true }: UseStudentLiveSessionOptions = {}) => {
  const attach = useStudentLiveSessionStore(state => state.attach);

  useEffect(() => {
    if (!enabled) return undefined;
    return attach();
  }, [enabled, attach]);

  const activeSessionId = useStudentLiveSessionStore(state => state.activeSessionId);
  const joinNotification = useStudentLiveSessionStore(state => state.joinNotification);
  const removalNotification = useStudentLiveSessionStore(state => state.removalNotification);
  const setActiveSessionId = useStudentLiveSessionStore(state => state.setActiveSessionId);

  return {
    activeSessionId,
    joinNotification,
    removalNotification,
    setActiveSessionId,
  };
};

export default useStudentLiveSession;
